module.exports = __webpack_public_path__ + "static/media/53-iveco.52125ec4.jpg";